import injectStyles from 'react-jss'
import React from 'react'
import { styles } from './styles'
import classNames from 'classnames'
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator'

const GenericFlatButton = ({
  type,
  title,
  icon,
  disabled,
  onClick,
  loading,
  classes,
  customStyles,
}) => {
  return (
    <div
      className={classNames({
        [classes.wrapper]: title,
        [classes.outlinedWrapper]: type == 'outline' && !disabled,
        [classes.filledWrapper]: type == 'filled' && !disabled,
        [classes.textTypeWrapper]: type == 'text',
        [classes.underline]: type == 'underline' && !disabled,
        [classes.disabledWrapper]: disabled,
        [customStyles]: true,
      })}
      onClick={disabled ? () => {} : onClick}
      cypress_id={`ambassadorSection${title}Btn`}
    >
      <div className={classes.buttonContent}>
        {icon && <div className={classes.icon}>{icon}</div>}
        <div className={classes.title}>
          {loading ? (
            <div className={classes.loader}>
              <LoadingIndicator
                size={14}
                style={{ height: '14px' }}
                label={null}
              />{' '}
            </div>
          ) : (
            title
          )}
        </div>
      </div>
    </div>
  )
}

export default injectStyles(styles)(GenericFlatButton)
